export const STORAGE_KEYS = {
  CART: 'cart_products',
};
